module.exports = __webpack_public_path__ + "assets/f946910fafc64d3742bbe44bc9dd5196-DSC_0757.jpg";